import React from "react";
import DandiButton from "./DandiButton";
import NoteButton from "./NoteButton";
import EditNoteButton from "./EditNoteButton";
import Raw_Button from "./Raw_Button";
import InitButton from "./InitButton"
import MouseButton from "./MouseButton"

const ButtonGroup = ({notes, experimentID, sessionID, togglePopup, toggleMousePopup, updateStatus, raw}) => {
  if(raw){
    return(
        <>
        <div style={{ display: "flex", flexDirection: "row" }}>
        <NoteButton                 
        notes={notes}
        sessionID={sessionID}
        loadStatus = {togglePopup}/>
        <InitButton                 
        sessionID= {sessionID}
        loadStatus = {updateStatus}/>
        <Raw_Button         
        sessionID= {sessionID}
        loadStatus = {updateStatus}/>
        <DandiButton
        sessionID= {sessionID}
        loadStatus = {updateStatus}/>
        </div>
        </>
    )
  } else {
    return(
        <>
        <div style={{ display: "flex", flexDirection: "row" }}>
        <NoteButton                 
        notes={notes}
        sessionID={sessionID}
        loadStatus = {togglePopup}/>
        <InitButton                 
        sessionID= {sessionID}
        loadStatus = {updateStatus}/>
        <DandiButton
        sessionID= {sessionID}
        loadStatus = {updateStatus}/>
        </div>
        </>
    )
  }
};

export default ButtonGroup;
